export default __webpack_public_path__ + "static/media/ListView.cd25962c.gif";